import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import CustomButton from "../../components/commons/CustomBtn";
import ContainerXL from "../../components/Container/ContainerXL";
import handlePasswordReset from "../../utils/resetPwd";
import "../login/login.css";
import toast from "react-hot-toast";

const PwdReset = () => {
  const [newMdp, setNewMdp] = useState("");
  const [confirmMdp, setConfirmMdp] = useState("");
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get("code");
    if (code) {
      setToken(code);
    }
  }, [searchParams]);

  const resetPwd = async () => {
    if (newMdp !== confirmMdp) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }

    const success = await handlePasswordReset(token, newMdp, confirmMdp);
    if (success) {
      navigate("/login");
    }
  };

  return (
    <ContainerXL className={"vh100"}>
      <div className="d-flex justify-content-between align-items-center bg-white h100 position-relative">
        <div className="w30 loginMobile d-flex flex-column align-items-center justify-content-center">
          <div className="d-flex flex-column align-items-center justify-content-center bg-white mx-auto loginContainer">
            <div className="loginLogo">
              <a href="/login">
                <img
                  src="./icons/logo_novanea1.svg"
                  alt="main_logo"
                  height={74}
                  width={334}
                />
              </a>
            </div>
            <div className="d-flex flex-column gap10 w100 mb-43">
              <input
                className="radius29 border-0 bg-white-grey py-20 px-20"
                type="password"
                placeholder="Nouveau mot de passe"
                onChange={(e) => setNewMdp(e.target.value)}
              />
              <input
                className="radius29 border-0 bg-white-grey py-20 px-20"
                type="password"
                placeholder="Confirmer mot de passe"
                onChange={(e) => setConfirmMdp(e.target.value)}
              />
            </div>
            <div className="d-flex flex-column gap20 w100">
              <CustomButton
                disabled={!newMdp || !confirmMdp}
                label="Confirmer"
                onClick={resetPwd}
                buttonClass={`bg-pink text-uppercase border-0 radius29 px-107 py-20`}
                labelClass="login-label fs14 fw-bold text-white letterSpacing-20"
              />
            </div>
          </div>
          <div className="text-center mb-3">
            <div className="mb-3">
              <img
                src="./icons/logo_novanea1.svg"
                alt="main_logo"
                height={24}
                width={108}
              />
            </div>
            <p className="fs9 medium softerGrey">Logiciel édité par Novanéa</p>
            <p className="fs9 medium softerGrey">
              Tous droits réservé ©Novanéa FRANCE 2025
            </p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://tendances.group/"
              className="fs9 medium softerGrey custom-button"
            >
              Tendances Group
            </a>
          </div>
        </div>
        <div className="w70 loginPhotoContainer">
          <img
            src="./assets/login_photo.webp"
            alt="login_photo"
            className="loginPhoto"
          />
        </div>
      </div>
    </ContainerXL>
  );
};

export default PwdReset;
